'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _textField = require('material-ui/lib/text-field');

var _textField2 = _interopRequireDefault(_textField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


// handleChange(handleChangeDataName || 'textboxrange', {from: 1, to: 30})
var BinaryTextBoxRange = function (_Component) {
  _inherits(BinaryTextBoxRange, _Component);

  function BinaryTextBoxRange(props) {
    _classCallCheck(this, BinaryTextBoxRange);

    var _this = _possibleConstructorReturn(this, (BinaryTextBoxRange.__proto__ || Object.getPrototypeOf(BinaryTextBoxRange)).call(this, props));

    var _this$props = _this.props,
        from_min = _this$props.from_min,
        to_min = _this$props.to_min;

    _this.state = {
      timer: null,
      from: props.defaultData === null ? parseInt(from_min, 10) : props.defaultData.from,
      to: props.defaultData === null ? parseInt(to_min, 10) : props.defaultData.to
    };
    return _this;
  }

  _createClass(BinaryTextBoxRange, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          from_min = _props.from_min,
          to_min = _props.to_min;

      if (nextProps.cancel) {
        var propFrom = nextProps.defaultData === null ? parseInt(from_min, 10) : nextProps.defaultData.from;
        var propTo = nextProps.defaultData === null ? parseInt(to_min, 10) : nextProps.defaultData.to;
        this.setState({ from: propFrom, to: propTo });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.from !== this.state.from || nextState.to !== this.state.to;
    }
  }, {
    key: 'handleFromChange',
    value: function handleFromChange(event) {
      var _this2 = this;

      var _props2 = this.props,
          handleChange = _props2.handleChange,
          handleChangeDataName = _props2.handleChangeDataName;

      this.setState({
        from: event.target.value
      });

      clearTimeout(this.state.timer);
      this.state.timer = setTimeout(function () {
        var validatedValue = _this2.validateFrom(_this2.state.from);
        _this2.setState({
          from: validatedValue
        }, function () {
          handleChange(handleChangeDataName, _this2.state);
        });
      }, 2000);
    }
  }, {
    key: 'handleToChange',
    value: function handleToChange(event) {
      var _this3 = this;

      var _props3 = this.props,
          handleChange = _props3.handleChange,
          handleChangeDataName = _props3.handleChangeDataName;

      this.setState({
        to: event.target.value
      });

      clearTimeout(this.state.timer);
      this.state.timer = setTimeout(function () {
        var validatedValue = _this3.validateTo(_this3.state.to);
        _this3.setState({
          to: validatedValue
        }, function () {
          handleChange(handleChangeDataName, _this3.state);
        });
      }, 2000);
    }
  }, {
    key: 'checkNumber',
    value: function checkNumber(value) {
      return (/^\d+$/.test(value)
      );
    }
  }, {
    key: 'validateTo',
    value: function validateTo(value) {
      var returnVal = this.props.to_min;
      if (this.checkNumber(value)) {
        if (parseInt(value, 10) > 0 && value > this.state.from) {
          returnVal = value;
        }
      }
      return returnVal;
    }
  }, {
    key: 'validateFrom',
    value: function validateFrom(value) {
      var returnVal = this.props.from_min;
      if (this.checkNumber(value)) {
        if (parseInt(value, 10) > parseInt(this.props.from_min, 10) && value < this.state.to) {
          returnVal = value;
        }
      }
      return returnVal;
    }
  }, {
    key: 'sleep',
    value: function sleep(time) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, time);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./BinaryTextBoxRange.scss');
      var handleChangeDataName = this.props.handleChangeDataName;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { key: handleChangeDataName, className: styles.binary_filter_textbox_range_container },
          _react2.default.createElement(
            'span',
            null,
            'From: '
          ),
          _react2.default.createElement(_textField2.default, {
            hintText: 'From',
            className: styles.binary_filter_textbox_from,
            value: this.state.from,
            onChange: this.handleFromChange.bind(this)
          }),
          _react2.default.createElement(
            'span',
            null,
            'To: '
          ),
          _react2.default.createElement(_textField2.default, {
            hintText: 'To',
            className: styles.binary_filter_textbox_to,
            value: this.state.to,
            onChange: this.handleToChange.bind(this)
          })
        )
      );
    }
  }]);

  return BinaryTextBoxRange;
}(_react.Component);

BinaryTextBoxRange.propTypes = {
  handleChange: _propTypes2.default.func.isRequired,
  handleChangeDataName: _propTypes2.default.string,
  cancel: _propTypes2.default.bool,
  from_min: _propTypes2.default.number,
  to_min: _propTypes2.default.number,
  defaultData: _propTypes2.default.object
};
BinaryTextBoxRange.defaultProps = {
  handleChangeDataName: 'textboxrange',
  cancel: false,
  defaultData: {
    from: 0,
    to: 30
  },
  from_min: 3,
  to_min: 30
};
exports.default = BinaryTextBoxRange;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryTextBoxRange/BinaryTextBoxRange.js
// module id = 2165
// module chunks = 1